import { Switch, SwitchField } from './fragments/Switch';
import { Label } from './fragments/FieldSet';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  falseLabel?: string;
  required?: boolean;
  name: string;
}

export const SwitchComponent: React.FC<SwitchProps> = ({
  checked,
  onChange,
  disabled,
  label,
  falseLabel,
  required,
  name
}) => {
  return (
    <div className='flex items-start gap-2'>
      <Switch
        className='flex-none mt-0.5'
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <Label required={required}>{falseLabel && !checked ? falseLabel : label}</Label>
    </div>
  );
};
